import Vue from 'vue';
import Vuex from 'vuex';
import { createAuthStore } from './AuthStore';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        showLoader: false,

        snackbar: {
            show: false,
            text: '',
            color: 'error',
        },

        headerTitle: '',

        addPlaceLocation: null,
    },
    mutations: {
        setSnackbar(state: any, data: any): void {
            state.snackbar.show = true;
            state.snackbar.text = data.text;
            state.snackbar.color = data.color || 'error';
        },

        showLoader(state: any): void {
            state.showLoader = true;
        },
        hideLoader(state: any): void {
            state.showLoader = false;
        },

        setHeaderTitle(state: any, title: string|null): void {
            state.headerTitle = title;
        },

        setAddPlaceLocation(state: any, location: any): void {
            state.addPlaceLocation = location;
        },
    },
    actions: {},
    modules: {
        auth: createAuthStore(),
    },
});
